var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.84 113.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2,.cls-3,.cls-4{mix-blend-mode:screen;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 43.42,
    y1: -0.08,
    x2: 43.42,
    y2: 128.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6acdee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006db7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 43.42,
    y1: -0.08,
    x2: 43.42,
    y2: 128.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 43.42,
    x2: 43.42,
    y2: 60.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bc9f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.45,42.92l-10.32-13A30.21,30.21,0,0,1,71.3,60.45a29.43,29.43,0,1,1-55.76,0A30.23,30.23,0,0,1,19.66,30L9.4,42.92a43.42,43.42,0,1,0,68.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.47,51.62,56.23,38.7a16.25,16.25,0,1,1-25.54-.09l-10.32,13a29.72,29.72,0,0,0-4.83,8.83,30.25,30.25,0,0,0,51.59,7,30,30,0,0,0,4.17-7A29.72,29.72,0,0,0,66.47,51.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.68,48.71A30,30,0,0,1,71.3,60.45a29.72,29.72,0,0,0-4.83-8.83L56.23,38.7l-.07-.09L43.42,22.54,30.69,38.61l-10.32,13a29.72,29.72,0,0,0-4.83,8.83A30.23,30.23,0,0,1,19.66,30l.05-.07L43.42,0,67.13,29.91A30.23,30.23,0,0,1,73.68,48.71Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.50dbdc4d21e7046cb1e19d61e3aec448.svg";
export { ForwardRef as ReactComponent };